export const escapeHtml = (unsafe = '') => {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

export const afterSanitizeAttributes = (currentNode) => {
  if ('target' in currentNode) {
    currentNode.setAttribute('target', '_blank');
  }
};

// ISO R-15: le icone dei comandi rapidi (icon_svg) le scrive qualsiasi agente
// e valgono per tutto l'account. Solo SVG statico: niente HTML (<img onerror>),
// niente <script>/<foreignObject> e niente elementi che caricano o animano.
export const SVG_ICON_SANITIZE_CONFIG = {
  USE_PROFILES: { svg: true, svgFilters: true },
  FORBID_TAGS: [
    'foreignobject',
    'animate',
    'animatemotion',
    'animatetransform',
    'set',
    'use',
    'image',
    'feimage',
  ],
};

// Risposte dell'assistente nella sidebar: i default di DOMPurify piu' lo
// schema otello:// dei link interni (dashboard/helper/rightSidebarAppLinks:
// solo le destinazioni in lista bianca diventano link nel markdown, e il click
// lo intercetta RightSidebar con $router.push). Stessa espressione di
// DOMPurify 3 (IS_ALLOWED_URI) con `otello` tra gli schemi.
export const ASSISTANT_SANITIZE_CONFIG = {
  ALLOWED_URI_REGEXP:
    /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix|otello):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
};

// Configurazioni della direttiva v-dompurify-html: senza argomento usa i
// default di DOMPurify (formattazione, stili inline e immagini restano; script,
// gestori on*, javascript: e iframe no); v-dompurify-html:svg per le icone,
// v-dompurify-html:assistant per le risposte dell'assistente.
export const domPurifyConfig = {
  hooks: {
    afterSanitizeAttributes,
  },
  namedConfigurations: {
    svg: SVG_ICON_SANITIZE_CONFIG,
    assistant: ASSISTANT_SANITIZE_CONFIG,
  },
};
